import styled from "styled-components";
import FlexBox from "../FlexBox";

const PageHolder = styled(FlexBox)`
  max-width: 1100px;
  margin: 0 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  display: flex;
  width: 100%;
  height: auto;

`
export const Styled = {
    PageHolder
}